import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import { LocalStorageService } from 'src/app/services/global/local-storage.service';

@Component({
  selector: 'obpp-user-tabs',
  templateUrl: './obpp-user-tabs.component.html',
  styleUrls: ['./obpp-user-tabs.component.scss'],
})
export class ObppUserHomeTabsComponent implements OnInit {
  private allLinks = [
    { title: 'ACC_SUMMARY', fragment: '/user/account-summary' },
    { title: 'DISPUTE', fragment: '/user/account-dispute' },
    { title: 'MANAGE_BC_ACC', fragment: '/user/manage-accounts' },
    { title: 'WEEKLY_PGM', fragment: '/user/autopay' },
    { title: 'PROFILE', fragment: '/user/user-profile' },
  ];

  private invoiceOnlyJourneyTabLinks = [
    { title: 'ACC_SUMMARY', fragment: '/user/account-summary' },
    { title: 'MANAGE_BC_ACC', fragment: '/user/manage-accounts' },
    { title: 'WEEKLY_PGM', fragment: '/user/autopay' },
    { title: 'PROFILE', fragment: '/user/user-profile' },
  ];

  links = [...this.allLinks];
  activeIdString = '/user/autopay';
  isAdmin: boolean = false;
  isViewCustScreen: boolean = false;

  constructor(
    private translate: TranslateService,
    public route: ActivatedRoute,
    public dataSharingService: DataSharingService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.dataSharingService.activeIdString.subscribe((aid) => {
      this.activeIdString = aid;
    });

    // Read initial value from localStorage (survives page refresh)
    const stored = this.localStorageService.get('invoiceOnlyJourney');
    this.links = stored
      ? [...this.invoiceOnlyJourneyTabLinks]
      : [...this.allLinks];

    // React to runtime changes (when the switch component resolves)
    this.dataSharingService.hideDisputeTab.subscribe((hide) => {
      this.links = hide
        ? [...this.invoiceOnlyJourneyTabLinks]
        : [...this.allLinks];
    });
  }

  updateActiveId(aid: string) {
    this.activeIdString = aid;
    this.dataSharingService.activeIdString.next(aid);
    this.dataSharingService.enrollForAutoPay.next([]);
  }
}
